<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">{{ title }}</div>
      <div class="right"></div>
    </div>
    <div class="main">
      <el-form
        :inline="false"
        ref="rulesForm"
        :rules="rules"
        :model="queryParams"
        label-width="125px"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="queryParams.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select
            v-model="queryParams.gender"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in genderList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="国籍" prop="country">
          <el-select
            v-model="queryParams.country"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in countryList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="聘用方式" prop="employ_method">
          <el-select
            v-model="queryParams.employ_method"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in employList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="年龄">
                    <el-input v-model="queryParams.md" placeholder="请输入"></el-input>
                </el-form-item> -->
        <!-- <el-form-item label="用户类型">
          <el-select
            v-model="queryParams.user_type"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in userTypeList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="queryParams.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="card_type">
          <el-select
            v-model="queryParams.card_type"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in codeTypeList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码" prop="card_code">
          <el-input
            v-model="queryParams.card_code"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="教资编号"  prop="teacher_id">
          <el-input
            v-model="queryParams.teacher_id"
            placeholder="请输入"
          ></el-input>
        </el-form-item> -->
      </el-form>
    </div>
    <footer>
      <el-button style="width: 120px" type="primary" size="" @click="save()"
        >保存</el-button
      >
      <el-button
        style="margin-left: 20px; width: 120px"
        size=""
        @click="toIndex()"
        >取消</el-button
      >
    </footer>
  </div>
</template>
<script>
import { addMember, updateMember, getMustField } from "@/api/user/userCenter";
import _ from "lodash";
import {
  validatePhone,
  validateIdNo,
  validateEMail,
  validateIdcard,
  validatePhoneTwo,
} from "@/utils/validate.js";
export default {
  props: ["info", "title"],
  components: {},
  data() {
    return {
      queryParams: {
        name: "",
        card_type: "",
        phone: "",
        card_code: "",
        teacher_id: "",
        user_type: " ",
        gender: "",
        country: "",
        employ_method: "",
      },
      codeTypeList: [
        { id: "0", label: "中国居民身份证", value: "0" },
        { id: "1", label: " 护照", value: "1" },
        { id: "6", label: "香港（港澳居民来往内地通行证）", value: "6" },
        { id: "7", label: "澳门（港澳居民来往内地通行证）", value: "7" },
      ],
      userTypeList: [
        { id: "1", label: "老师    ", value: "1" },
        { id: "3", label: "工作人员    ", value: "3" },
        { id: "4", label: "行政人员", value: "4" },
      ],
      employList: [
        { id: "1", label: "全职    ", value: "qz" },
        { id: "2", label: "兼职    ", value: "jz" },
      ],
      genderList: [
        { id: "0", label: "女", value: 0 },
        { id: "1", label: "男", value: 1 },
        { id: "2", label: "保密 ", value:2 },
      ],
      countryList: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        country: [{ required: true, message: "请选择国籍", trigger: "blur" }],
        employ_method: [
          { required: true, message: "请选择聘用方式", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        card_type: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
        card_code: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          //  { validator: validateIdNo, trigger: "blur" },
        ],
        teacher_id: [
          { required: true, message: "请输入教资编号", trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  watch: {
    "info": function(e) {
      if (e) {
        console.log('编辑用户信息-----',this.info);
        // for (let k in this.info) {
        //   this.queryParams[k] = this.info[k];
        // }
        let _info=this.info
        this.queryParams.name = _info.name;
        this.queryParams.gender = _info.gender;
         this.queryParams.phone = _info.phone;
        this.queryParams.card_code = _info.card_code;
        this.queryParams.card_type=_info.card_type
        if(this.info.user_id){
            this.queryParams.card_type =_info.card_type+'' ;
        }else{
          this.queryParams.card_type=''
        }
      } else {
        for (let k in this.queryParams) {
          this.queryParams[k] = "";
        }
        // this.$refs["rulesForm"].resetFields();//重置表单
      }
    },
  },
  created() {
    this.ininData();
  },
  methods: {
    async ininData() {
      let params = {
        top_org_id: sessionStorage.getItem("orgId"), //	String	是	机构、学校等组织id
        member_type: "member", //	String	是	member:部门成员
        type: "add", //   String	是	add:新增，update更新
        user_id: "", //   String	否	获取用户的更新字段时必填
      };
      const { code, result } = await getMustField(params);
      console.log("获取必填字段get--", code, result);
      if (code === "000000") {
        result.forEach((item) => {
          if (item.title === "国籍") {
            for (var i = 0; i < item.select_list.length; i++) {
              this.countryList.push({
                id: i,
                label: item.select_list[i],
                value: i,
              });
            }
          }
        });
      }
    },
     save: _.throttle(
      async function () {
        if (this.info.user_id) {
        const _queryParams = this.queryParams;
        let params = {
          top_org_id: sessionStorage.getItem("orgId"),
          usession_id: sessionStorage.getItem("usessionid"), //	会话ID
          to_user_id: this.info.user_id, //被更新的用户id
          phone: _queryParams.phone.includes("*") ? "" : _queryParams.phone,
          // account: "", //系统账号[账号属性]，选其一  201961100220267272
          card_type: _queryParams.card_type,
          card_code: _queryParams.card_code.includes("*")
            ? ""
            : _queryParams.card_code, //420281199111111299
          teacher_train_id: "",
          teacher_id: _queryParams.teacher_id.includes("*")
            ? ""
            : _queryParams.teacher_id, //13034407973  教师资格证17位数字
          name: _queryParams.name,
          parent_dep_ids: sessionStorage.getItem("orgId"), //被加入的部门id，多个使用英文逗号分隔(,)
          user_type: "5", //被添加的用户类型(1老师，3工作人员，4行政人员)
          member_show_filed: {
            gender: _queryParams.gender,
            country: _queryParams.country,
            employ_method: _queryParams.employ_method,
          },
        };
        if (params.phone == "") {
          delete params.phone;
        }
        if (params.card_code == "") {
          delete params.card_code;
        }
        if (params.teacher_id == "") {
          delete params.teacher_id;
        }
        const { code, message } = await updateMember(params);
        if (code === "000000") {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.toIndex();
        } else {
          this.$message({
            type: "error",
            message: message,
          });
        }
      } else {
        const _queryParams = this.queryParams;
        let params = {
          top_org_id: sessionStorage.getItem("orgId"),
          usession_id: sessionStorage.getItem("usessionid"), //	会话ID
          to_user_id: this.info.user_id, //被更新的用户id
          phone: _queryParams.phone,
          account: "", //系统账号[账号属性]，选其一  20196110022026727
          card_type: _queryParams.card_type,
          card_code: _queryParams.card_code, //420297199122222987
          teacher_train_id: "",
          teacher_id: _queryParams.teacher_id,
          name: _queryParams.name,
          parent_dep_ids: sessionStorage.getItem("orgId"), //被加入的部门id，多个使用英文逗号分隔(,)
          user_type: "5", //	被添加的用户类型(1老师，3工作人员，4行政人员,5企业人员)
          member_show_filed: {
            gender: _queryParams.gender,
            country: _queryParams.country,
            employ_method: _queryParams.employ_method,
          },
        };
        this.$refs["rulesForm"].validate(async (valid) => {
          if (valid) {
            const { code, message } = await addMember(params);
            console.log("机构添加部门成员--", params, code, message);
            if (code === "000000") {
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.toIndex();
            } else {
              this.$message({
                type: "error",
                message: message,
              });
            }
          } else {
            this.$message({
              type: "error",
              message: "请输入必填项!",
            });
          }
        });
      }
      },
      3000,
      { leading: true, trailing: false }
    ),
    toIndex() {
      this.$emit("to-index");
      this.$refs["rulesForm"].resetFields();//重置表单
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .main {
    width: 100%;
    height: 100%;
    // margin-top: 80px;
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
    }
    .input-list {
      display: flex;
      align-items: flex-start;
      margin-top: 10px;
      p {
        width: 90px;
        line-height: 21px;
        font-size: 14px;
        color: #606266;
      }
    }
  }
  footer {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }
  .Homeboxtop_nav_tab {
    span {
      width: 100px;
      font-weight: 400;
      font-size: 15px;
      margin-right: 40px;
      cursor: pointer;
      padding-bottom: 15px;
    }
    .active {
      color: #4991e1;
      border-bottom: 3px solid #4991e1;
    }
  }
  .table {
    width: 100%;
    margin-top: 30px;
    border: 1px solid #eee;
    .td-1 {
      width: 30%;
      display: inline-block;
      position: relative;
      top: -8px;
    }
    .td-2 {
      width: 70%;
      display: inline-block;
    }
    .file {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
        img {
          margin-right: 20px;
        }
        span {
          width: 200px;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      a {
        font-size: 14px;
        line-height: 48px;
        color: #4991e1;
        margin-right: 20px;
      }
    }
    li {
      display: inline-block;
      width: 50%;
      height: 100%;
      text-align: center;
      font-size: 14px;
      line-height: 48px;
      color: #7a8da2;
      position: relative;
    }
    .table-header {
      width: 100%;
      height: 48px;
      background: #fafafa;
      border: 1px solid #eee;
      display: flex;
      div {
        height: 100%;
        text-align: center;
        font-size: 14px;
        line-height: 48px;
        color: #7a8da2;
      }
    }
  }
  .table_2_tr {
    font-size: 14px;
    line-height: 48px;
    color: #7a8da2;
    text-align: center;
  }
}
::v-deep .el-form .el-input__inner {
  width: 200px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}
</style>
